import { cEl } from '../../../util';
import overviewRobot from '../../../assets/images/learn/overview-robot.png';

function Overview() {
    const article = cEl('article');
    article.classList.add('overview');

    const contents = cEl('div');
    contents.classList.add('overview-contents');
    contents.innerHTML = `
    <h2>병원 서비스 로봇 배우기</h2>
    <span>병원에서 로봇이라고 하면 수술 혹은 재활 로봇을 떠올리지만,<br>‘서비스 로봇＇은 단순 반복 작업을 대신하여 의료진이 더욱 중요한 업무에 집중할 수 있도록 돕습니다.</span>
    `;

    const img = cEl('img');
    img.src = overviewRobot;
    img.alt = 'robot';

    article.append(contents, img);

    return article;
}

export default Overview;
